import { reduxForm, Field, getFormValues } from 'redux-form';
import { Form, Grid } from 'semantic-ui-react';
import { withRouter } from 'react-router';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import {
  InputField,
  DatePickerField,
  CheckboxField,
} from 'Common/SemanticWrapper';
import { NYSirsExportFieldEnum as Fields } from 'Common/FieldEnum';
import { NEW_YORK_SIRS_EXPORT_FORM_NAME } from 'Common/FormEnum';
import { getFiscalYear } from 'Common/GeneralHelper';
import { TitledCard } from 'Components/';

import { dateOptions } from '../constants/sirsConstants';

class NewYorkSirsExportForm extends Component {
  render() {
    const { loading, formValues } = this.props;

    return (
      <Form name={NEW_YORK_SIRS_EXPORT_FORM_NAME}>
        <TitledCard
          style={{ width: '60vw', minWidth: '700px' }}
          title="SIRS Report"
        >
          <Grid>
            <Grid.Row columns={8} className={'ny-sirs-first-row'}>
              <Grid.Column width={7}>
                <Field
                  className={'beds-input-current'}
                  label={'BEDS Code'}
                  component={InputField}
                  placeholder="NY########"
                  name={Fields.BedsCode}
                  loading={loading}
                  maxLength={10}
                  type="text"
                />
              </Grid.Column>
              <Grid.Column width={6}>
                <Field
                  component={CheckboxField}
                  name={Fields.IncludeEligibilityTypeCode}
                  toggle
                  label={'Include Eligibility Type Code'}
                  className={'ny-sirs-eligibility-toggle'}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={6}>
                <ReduxFormButtonGroup
                  formName={NEW_YORK_SIRS_EXPORT_FORM_NAME}
                  fieldName={Fields.TodayOrOtherDate}
                  options={dateOptions}
                  disabled={loading}
                  label={'As of Today or Another Date'}
                />
              </Grid.Column>
              <Grid.Column width={6}>
                <Field
                  className={
                    formValues[Fields.TodayOrOtherDate] === 0
                      ? 'sirs-export-disabled'
                      : ''
                  }
                  component={DatePickerField}
                  name={Fields.AsOfDate}
                  maxDate={moment()}
                  minDate={getMinDate()}
                  openToDate={moment()}
                  label={'As of Date'}
                  disabled={
                    loading || formValues[Fields.TodayOrOtherDate] === 0
                  }
                  type="text"
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
      </Form>
    );
  }
}

const getMinDate = () => {
  return moment((getFiscalYear(new Date()) - 1).toString() + '/07/01');
};

const validate = (values, props) => {
  const errors = {};

  if (
    !values[Fields.BedsCode] ||
    values[Fields.BedsCode].search(/^NY[0-9]{6,8}/) !== 0
  ) {
    errors[Fields.BedsCode] =
      'Must prefix BEDS Code with "NY" followed by 6 to 8 integers.';
  }

  if (
    values[Fields.BedsCode] &&
    props.assignedBedsCodes.includes(values[Fields.BedsCode]) &&
    values[Fields.BedsCode] !== props.initialBedsCode
  ) {
    errors[Fields.BedsCode] = 'BEDS Code is already used.';
  }
  return errors;
};

const mapStateToProps = (state) => {
  return {
    formValues: getFormValues(NEW_YORK_SIRS_EXPORT_FORM_NAME)(state),
  };
};

const NewYorkSirsExportFormExport = reduxForm({
  form: NEW_YORK_SIRS_EXPORT_FORM_NAME,
  validate,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(withRouter(connect(mapStateToProps)(NewYorkSirsExportForm)));

export { NewYorkSirsExportFormExport };



// WEBPACK FOOTER //
// ./src/pages/newyorksirsexport/components/NewYorkSirsExportForm.js